/**
 * v11.8 V118-0-6 (ADR-0117 §1, D-118-3): the closed value lists of the obligation record and the intake package.
 * The arrays are the type source; migrations 1050 / 1051 seed the lookup tables with the same values (D-115-2), and
 * packages/cloudflare/src/db/migration-1050-1052-obligation-sets.test.ts asserts both directions.
 *
 * Adding a value: append it here and add a one-row INSERT migration for its lookup (both dialects).
 */
/** What a record asks of whom it binds. A `permission` never yields a control or a duty (ADR-0117 §1). */
export const DEONTIC_KINDS = ['obligation', 'prohibition', 'permission', 'exemption'];
/** The crosswalk's private / public / mixed. */
export const BINDS_WHOM_SCOPES = ['private', 'public', 'mixed'];
/** Who must act. The BL-45 four plus `platform` and `public_body` (owner 2026-11-01). */
export const ACTOR_CLASSES = ['deployer', 'developer', 'provider', 'platform', 'public_body', 'other'];
/** D-118-3 question kinds; the ADR-0076 reason codes map onto them (ADR-0118). */
export const INTAKE_QUESTION_KINDS = ['ambiguity', 'conflict', 'missing_source', 'low_fixture_coverage'];
/** Package statuses (PRD §4.3 workflow). */
export const INTAKE_PACKAGE_STATUSES = [
    'drafting', 'awaiting_review', 'approved', 'applied', 'rejected', 'failed', 'expired', 'superseded',
];
/** Each list and the lookup table that holds its rows. */
export const INTAKE_LOOKUPS = {
    deontic_kinds: DEONTIC_KINDS,
    binds_whom_scopes: BINDS_WHOM_SCOPES,
    actor_classes: ACTOR_CLASSES,
    intake_question_kinds: INTAKE_QUESTION_KINDS,
    intake_package_statuses: INTAKE_PACKAGE_STATUSES,
};
/** BL-45's actor (`DutyActor`) for an actor class: `platform` and `public_body` read as `other` (ADR-0117 §5). */
export function dutyActorOf(actor) {
    return actor === 'deployer' || actor === 'developer' || actor === 'provider' ? actor : 'other';
}
//# sourceMappingURL=intake-enums.js.map